import { Link } from "react-router-dom";
import { ArrowUpRight, Mail } from "lucide-react";
import { Star, Wordmark } from "./brand/Logo";
import { useLang } from "../i18n/LangContext";
import { EMAIL, EMAIL_HREF, SOCIALS } from "../i18n/strings";

const PAGES = ["home", "work", "services", "studio", "contact", "sheet"];

export const Footer = () => {
  const { t, path } = useLang();
  return (
    <footer className="relative overflow-hidden border-t border-white/10 bg-ink pt-20 text-ivory" data-testid="site-footer">
      <div className="mx-auto grid max-w-[1440px] gap-14 px-5 md:grid-cols-12 md:px-10">
        <div className="md:col-span-5">
          <p className="label text-lav">{t.common.tagline}</p>
          <p className="mt-6 max-w-sm font-display text-2xl font-light leading-snug text-ivory/90">
            STARVYNT Creative Studio
          </p>
          <p className="mt-3 max-w-sm text-sm text-mist">{t.common.remote}</p>
          <a href={EMAIL_HREF} className="mt-8 inline-flex items-center gap-3 font-display text-xl text-ivory transition-colors hover:text-lav" data-testid="footer-email-link">
            <Mail className="h-4 w-4 text-lav" />{EMAIL}
          </a>
        </div>
        <div className="md:col-span-3">
          <p className="label mb-6 text-mist">{t.footer.pages}</p>
          <ul className="space-y-3">
            {PAGES.map((k) => (
              <li key={k}>
                <Link to={path(k)} className="link-star text-sm text-ivory/80 hover:text-ivory" data-testid={`footer-link-${k}`}>
                  {k === "sheet" ? t.sheet.title : t.nav[k]}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="label mb-6 text-mist">{t.footer.connect}</p>
          <ul className="space-y-3">
            {SOCIALS.map((s) => (
              <li key={s.key}>
                <a href={s.href} target="_blank" rel="noopener noreferrer" data-testid={`footer-social-${s.key}`}
                  className="group flex items-center justify-between border-b border-white/10 pb-3 text-sm text-ivory/80 hover:text-ivory">
                  {s.label}<ArrowUpRight className="h-4 w-4 text-lav transition-transform group-hover:rotate-45" />
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="relative mx-auto mt-20 max-w-[1440px] px-5 md:px-10">
        <Wordmark className="w-full text-ivory/[0.06]" />
        <Star className="absolute right-10 top-0 h-10 w-10 text-lav md:right-16 md:h-14 md:w-14" />
      </div>
      <div className="mx-auto flex max-w-[1440px] flex-col justify-between gap-3 px-5 py-8 text-xs text-mist md:flex-row md:px-10">
        <span>© {new Date().getFullYear()} STARVYNT Creative Studio. {t.footer.rights}</span>
        <span className="flex gap-6">
          <span>starvynt.com</span>
          <Link to="/admin" className="hover:text-ivory" data-testid="footer-owner-login">{t.footer.inbox}</Link>
        </span>
      </div>
    </footer>
  );
};
